import { useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { UserContext } from '@/lib/User';
import {
  trackScreen,
  flushCurrentScreen,
  initVisibilityTracking,
  getScreenLabel,
  isCourseDashboardPath,
} from '@/lib/activityTracker';

export default function ActivityTracker() {
  const location = useLocation();
  const { user } = useContext(UserContext);

  useEffect(() => {
    initVisibilityTracking();
  }, []);

  useEffect(() => {
    if (!user?.session) return;

    const pathname = location.pathname;

    // Course dashboard sections are tracked inside CourseDashboard.jsx
    if (isCourseDashboardPath(pathname)) return;

    const path = pathname + location.search;
    const label = getScreenLabel(pathname);
    trackScreen(path, label);

    return () => flushCurrentScreen();
  }, [location.pathname, location.search, user?.session]);

  return null;
}
